import { css } from '@emotion/css';

import { AlignItems, Color, Display, Font, Spacing } from '../../styles';

export const button = (underlined: boolean = false) => css`
  color: ${Color.Brand6};
  ${Display.flex}
  ${AlignItems.center}
  ${Spacing.mx0}
  ${Spacing.px0}
  ${Font.md}
  cursor: pointer;
  white-space: normal;
  text-decoration: ${underlined ? 'underline' : 'none'} !important;

  &:hover {
    color: ${Color.Brand6};
  }

  &:focus {
    color: ${Color.Brand6};
  }
`;
